module.exports = __webpack_public_path__ + "img/eg-hk-03.d276d8f5.png";